import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { AnalyticsModule } from '@ddt-web/analytics';
import { CoreModule } from '@ddt-web/data-layer-components';
import { DataServiceModule } from '@ddt-web/data-service';

import { FamilyFooterComponent } from './family-footer.component';
import { FamilyInceptionDateComponent } from './family-inception-date/family-inception-date.component';

@NgModule({
	declarations: [FamilyFooterComponent, FamilyInceptionDateComponent],
	imports: [
		CommonModule,
		AnalyticsModule,
		CoreModule,
		CwpNgFrameworkModule,
		DataServiceModule,
		RouterModule
	],
	exports: [FamilyFooterComponent, FamilyInceptionDateComponent]
})
export class FamilyFooterModule { }
